import React from 'react'
import ChatHistory from './ChatHistory'
import Navbar from './SidebarNav'
import Search from './Search'
import { useNav } from '../contexts/NavContext'

const Sidebar = () => {
   const {isNavOpen} = useNav()

   return (
      <div className={`bg-purple-dark text-white z-20 fixed inset-y-0 left-0 top-0 bottom-0 ${isNavOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0 md:static transition-transform`}>
         <Navbar />
         <Search />
         <ChatHistory />
      </div>
   )
}

export default Sidebar